import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { RouteComponent } from '@app/route/route.component';
import {
  EmailAndPhone,
  UserRegistrationDto,
} from '@app/service/user-service/user.service';
import { HeaderService } from '@app/service/header/header.service';
import { StateService } from '@app/service/state/state.service';
import { email_validation_regexp } from '@assets/val/regexp';
import {
  CountryCodes,
  formatPhoneNumber,
  phoneNumberValidator,
} from 'web-component-library/projects/component-library/src/public-api';
import { PIAService } from '@app/service/pay-in-advance/pay-in-advance.service';
import { SelectorItem } from '@app/component/selector/selector.component';
import { ValuePipe } from '@app/shared/pipe/value.pipe';

@Component({
  selector: 'pia-email-and-phone-registration',
  templateUrl: './pia-email-and-phone-registration.component.html',
  styleUrls: [
    '../../page-shared.css',
    './pia-email-and-phone-registration.component.scss',
  ],
})
export class PiaEmailAndPhoneRegistrationComponent
  extends RouteComponent
  implements OnInit
{
  constructor(
    private formBuilder: FormBuilder,
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private PIAService: PIAService,
    private valuePipe: ValuePipe
  ) {
    super(router, route, stateService, headerService);
  }
  form: FormGroup;
  showError = false;
  preExistingContactInfo: UserRegistrationDto;
  loading: boolean = true;
  selectorItems: SelectorItem[] = null;
  selectedItem: SelectorItem = null;
  modalActive: boolean = false;
  async ngOnInit(): Promise<void> {
    try {
      this.preExistingContactInfo =
        await this.PIAService.getPreExistingContactInfo().toPromise();
    } catch (error) {
      this.handleError(error);
    }

    this.form = this.formBuilder.group({
      email: [
        this.preExistingContactInfo.email.value || '',
        [Validators.pattern(email_validation_regexp), Validators.required],
      ],
      phoneNumber: [
        this.preExistingContactInfo.phoneNumber.value || '',
        [
          phoneNumberValidator(CountryCodes.ALL, this.state.market),
          Validators.required,
        ],
      ],
    });
    this.loading = false;
  }

  async handleCtaClick(): Promise<void> {
    if (this.form.valid) {
      try {
        const formData: EmailAndPhone = {
          email: this.form.controls.email.value.trim().toLowerCase(),
          phoneNumber: formatPhoneNumber(
            this.form.controls.phoneNumber.value,
            this.state.market
          ),
        };
        const registerResp = await this.PIAService.registerEmailAndPhone(
          formData
        ).toPromise();

        if (registerResp.success) {
          await this.navigate();
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      this.showError = true;
    }
  }
  deactivateModal(): void {
    this.modalActive = false;
  }

  getModalPurchaseInfo(): void {
    this.selectorItems = [
      {
        tab: 'Purchase',
        title: 'Summary',
        descriptions: [{ text: this.state.paymentInformation.description }],
        lineItems: this.state.paymentInformation?.lineItems,
        totalValue: `Total incl. VAT: ${this.valuePipe.transform(
          this.state.totalCheckoutValue
        )}`,
      },
      {
        tab: 'Terms',
        title: 'Pay in advance',
        descriptions: [
          {
            text: `With Zaver’s Pay in Advance your order will be processed as soon as we receive payment from you. Use the payment information displayed on the order confirmation page here in the checkout, or find the email and pdf invoice sent to the email address you specified.`,
          },
        ],
      },
    ];

    this.selectedItem = this.selectorItems[0];
    this.modalActive = true;
  }

  openModalWithTerms(): void {
    this.getModalPurchaseInfo();
  }
}
